import { useState } from 'react';

const useFormWidgetsConfig = defaultWidgetsConfig => {
  const [widgetsConfig, setWidgetsConfig] = useState(defaultWidgetsConfig);

  const updateWidgetLimit = (widgetName, limit) =>
    setWidgetsConfig(prevState => ({
      ...prevState,
      [widgetName]: {
        ...prevState[widgetName],
        limit
      }
    }));

  const toggleShowAllSegments = widgetName =>
    setWidgetsConfig(prevState => ({
      ...prevState,
      [widgetName]: {
        ...prevState[widgetName],
        show_all_segments: !prevState[widgetName].show_all_segments
      }
    }));

  return {
    widgetsConfig,
    updateWidgetLimit,
    toggleShowAllSegments
  };
};

export default useFormWidgetsConfig;
